export default {
  props: {
    disabled: Boolean,
    name: {
      type: String,
      required: true,
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    value: String,
    validator: String,
  },
  data() {
    return {
      focus: false,
    };
  },
  computed: {
    textAreaModifiers() {
      return {
        'textarea--has-value': this.value,
        'textarea--is-focused': this.focus,
      };
    },
  },
  methods: {
    handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
    },
    handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);
    },
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/textarea/textarea.js